const child = state => state.child

export default {
  child
}
